import subscriptionRenewalIcon from "../imgs/subscription-renewal.svg"
import maintainenceIcon from "../imgs/build.svg"
import priceIcon from "../imgs/attach_money.svg"

export const iconKeyToImgMapping = {
  "TEMPLATE NOTIFICATION": subscriptionRenewalIcon,
  "SCHEDULED MAINTENANCE": maintainenceIcon,
  "PRICE INCREASE": priceIcon,
  "ADD CREDIT 3 DAYS BEFORE SUBSCRIPTION RENEWS": subscriptionRenewalIcon,
}
